export const LANGUAGE_OPTIONS = [
  { value: '',   label: 'Auto-detect', flag: '' },
  { value: 'en', label: 'English',     flag: 'gb' },
  { value: 'es', label: 'Español',     flag: 'es' },
  { value: 'pt', label: 'Português',   flag: 'br' },
];

export const LANGUAGE_LABEL_MAP: Record<string, { label: string; flag: string }> = Object.fromEntries(
  LANGUAGE_OPTIONS.filter((o) => o.value).map((o) => [o.value, { label: o.label, flag: o.flag }])
);
